enum AnnotationReplyDialogFields {
	CREATOR = "creator",
	SUBJECT = "subject",
	CONTENTS = "contents"
}

export default AnnotationReplyDialogFields;